import { Vector2 } from 'three'
import { Easing, Tween } from '@tweenjs/tween.js'
import { tweenGroup } from './tweenGroup'

export class Word {
	private readonly node: HTMLElement
	private readonly hasDescender: boolean
	private readonly tweens: Tween[] = []
	public p1 = new Vector2()
	public p2 = new Vector2()
	public scale = new Vector2()
	public offset = new Vector2()
	public radius = 0

	constructor(node: HTMLElement, hasDescender = false) {
		this.node = node
		this.hasDescender = hasDescender
	}

	show() {
		this.tweens.forEach((tween) => tween.stop())
		this.tweens.length = 0

		this.tweens.push(
			new Tween({ scale: 0.85 }, tweenGroup)
				.to({ scale: 1 }, 750)
				.easing(Easing.Exponential.Out)
				.onUpdate(({ scale }) => {
					this.node.style.transform = `scale(${scale})`
				})
				.onStart(() => (this.node.style.opacity = `1`))
				.start()
		)
	}

	resize(wWidth: number, wHeight: number, wLeft: number, wTop: number, aspect: number) {
		const { width, height, left, top } = this.node.getBoundingClientRect()

		let x = left - wLeft
		let y = top - wTop
		let w = width
		let h = height

		const paddingX = height * 0.3
		const paddingY = height * (this.hasDescender ? 0.105 : 0.095)

		x -= paddingX
		w += paddingX * 2

		y -= paddingY
		h += paddingY * 2

		x += height * 0.025 //letter-spacing
		y += height * (this.hasDescender ? 0.1 : 0.01) //center visually

		w /= wWidth
		h /= wHeight

		x /= wWidth
		y /= wHeight

		this.radius = 0.5 * h * aspect

		x += this.radius
		w -= this.radius * 2

		y += h * 0.5
		y *= -aspect

		this.p1.set(x, y)
		this.p2.set(x + w, y)
	}

	dispose() {
		this.tweens.forEach((tween) => tween.stop())
		this.tweens.length = 0
	}
}
